import {
  headline,
  text,
  field,
  button, spacer, image,
} from '@components/Widgets/_contentItems/all'
import themes from '@components/Widgets/Templates/Themes/all'
import { settings, styling } from '@components/Widgets/Templates/_base'
import { type, maxWidth, position } from '@meta/widget/options'
import { tag, typeTag } from '@meta/widget/templates'

const info = {
  name: 'Step Into Style',
  templateID: '3',
  description: 'Add a touch of elegance and sophistication to your site with the "Step Into Style" widget. Featuring a sleek design and refined aesthetics, this widget is ideal for fashion and lifestyle brands looking to captivate their audience.',
  tags: [typeTag.POPUP, tag.LEAD_GENERATION],
}

const json = {
  id: 1346436,
  templateID: info.templateID,
  type: type.IMAGE_COLUMN,
  name: info.name,
  theme: themes.GRAY,
  active: true,
  settings: (() => {
    const customSettings = { ...settings }
    customSettings.position = position.CENTER
    customSettings.ribbonColor = '#FEFEFE'
    customSettings.closeButtonColor = 'rgb(242, 248, 248) '
    customSettings.sideImage = (() => {
      const customImage = JSON.parse(JSON.stringify(image))
      customImage.content.url = 'https://assets.onvocado.com/templates/step_into_style.png'
      return customImage
    })()

    return customSettings
  })(),
  styling: (() => {
    const customStyling = { ...styling }
    customStyling.maxWidth = maxWidth.EXTRA_LARGE
    customStyling.backgroundColor = 'rgb(173, 179, 179)'
    customStyling.backgroundImage = ''
    return customStyling
  })(),
  steps: [
    {
      id: '50i9h0',
      contentItems: [
        (() => {
          const customHeadline = JSON.parse(JSON.stringify(headline))
          customHeadline.content.text = 'Step into Style!'
          Object.assign(customHeadline.styling, {
            color: 'rgba(242, 248, 248, 1)',
            fontSize: '48px',
            textAlign: 'center',
            fontFamily: 'Kosugi',
            fontWeight: 'bold',
          })
          return customHeadline
        })(),
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          Object.assign(customSpacer.styling, { padding: '10px' })
          return customSpacer
        })(),
        (() => {
          const customText = JSON.parse(JSON.stringify(text))
          customText.content.text = '<p>Be the first to know about new arrivals & promotions.</p>'
          Object.assign(customText.styling, {
            color: 'rgba(242, 248, 248, 1)',
            fontSize: '20px',
            textAlign: 'left',
            fontFamily: 'Roboto',
            fontWeight: '400',
          })
          return customText
        })(),
        (() => {
          const customField = JSON.parse(JSON.stringify(field))
          customField.content.placeholder = 'Your Email Address'
          Object.assign(customField.styling, {
            color: 'rgba(115, 116, 116, 1)',
            fontSize: '16px',
            textAlign: 'left',
            fontFamily: 'Roboto',
            fontWeight: '400',
            borderColor: 'rgba(0, 0, 0, 0.3)',
            borderWidth: '0px',
            borderRadius: '4px',
            backgroundColor: 'rgba(242, 248, 248, 1)',
          })
          customField.settings.type = 'email'
          customField.settings.required = true
          customField.settings.label = 'Email address'

          return customField
        })(),
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          Object.assign(customSpacer.styling, { padding: '15px' })
          return customSpacer
        })(),
        (() => {
          const customButton = JSON.parse(JSON.stringify(button))
          customButton.content.text = 'SUBMIT'
          Object.assign(customButton.styling, {
            color: 'rgba(242, 248, 248, 1)',
            fontSize: '18px',
            fontFamily: 'Roboto',
            fontWeight: '500',
            borderColor: 'rgba(242, 248, 248, 1)',
            borderWidth: '2px',
            borderRadius: '4px',
            justifyContent: 'center',
            backgroundColor: 'rgba(173, 179, 179, 1)',
          })
          customButton.settings.action = 'next'
          customButton.settings.backBtn = false
          return customButton
        })(),
      ],
    },
    {
      id: '1r2ywh0',
      contentItems: [
        (() => {
          const customHeadline = JSON.parse(JSON.stringify(headline))
          customHeadline.content.text = 'THANK YOU.'
          Object.assign(customHeadline.styling, {
            color: 'rgba(242, 248, 248, 1)',
            fontSize: '48px',
            textAlign: 'center',
            fontFamily: 'Kosugi',
            fontWeight: 'bold',
          })
          return customHeadline
        })(),
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          Object.assign(customSpacer.styling, { padding: '10px' })
          return customSpacer
        })(),
        (() => {
          const customText = JSON.parse(JSON.stringify(text))
          customText.content.text = '<p>We\'ll keep you posted. In the meantime check out our latest arrivals.</p>'
          Object.assign(customText.styling, {
            color: 'rgba(242, 248, 248, 1)',
            fontSize: '20px',
            textAlign: 'left',
            fontFamily: 'Roboto',
            fontWeight: '400',
          })
          return customText
        })(),
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          Object.assign(customSpacer.styling, { padding: '20px' })
          return customSpacer
        })(),
        (() => {
          const customButton = JSON.parse(JSON.stringify(button))
          customButton.content.text = 'LATEST TRENDS'
          Object.assign(customButton.styling, {
            color: 'rgba(242, 248, 248, 1)',
            fontSize: '18px',
            fontFamily: 'Roboto',
            fontWeight: '500',
            borderColor: 'rgba(242, 248, 248, 1)',
            borderWidth: '2px',
            borderRadius: '4px',
            justifyContent: 'center',
            backgroundColor: 'rgba(173, 179, 179, 1)',
          })
          customButton.settings.action = 'url'
          customButton.settings.backBtn = false
          return customButton
        })(),
      ],
    },
  ],
}

export { json, info }
